import { type ClinicianTypeInput } from '@/lib/types';
import { type OnboardingScriptResponse, type SpecialtyTranscriptResponse } from '@/types';
import { scribeHttp } from '@/utils/scribeHTTP';
import { type OnboardingV2AssetsResponse } from '@heidi/growth';

export const getSpecialties = (country?: string, acceptLanguage?: string) => {
  // `Accept-Language` = the app's active UI language, overriding the browser
  // default. It only decides when no user document resolves (pre-account
  // onboarding surfaces); a stored account language wins server-side.
  const config = {
    ...(country && { params: { country } }),
    ...(acceptLanguage && { headers: { 'Accept-Language': acceptLanguage } }),
  };
  return scribeHttp.get<{
    specialties: ClinicianTypeInput[];
    total: number;
  }>('/specialties', Object.keys(config).length > 0 ? config : undefined);
};

export const getSpecialtyTranscript = (specialtyName: string, locale: string) => {
  return scribeHttp.get<SpecialtyTranscriptResponse>(
    `/specialties/transcript-by-name/${encodeURIComponent(specialtyName)}`,
    { params: { locale } }
  );
};

export const getSpecialtyOnboardingScript = (specialtyId: string) => {
  return scribeHttp.get<OnboardingScriptResponse>(
    `/specialties/${encodeURIComponent(specialtyId)}/onboarding-script`
  );
};

export const getSpecialtyOnboardingV2Assets = (
  specialtyName: string,
  locale?: string
) => {
  return scribeHttp.get<OnboardingV2AssetsResponse>(
    `/specialties/${encodeURIComponent(specialtyName)}/onboarding-v2-assets`,
    locale ? { params: { locale } } : undefined
  );
};
